/**
 * Keeps the Shopify Inbox chat launcher clear of the TOP page's mobile
 * fixed bottom bar (`.bottom-bar` in f-app.js), instead of hardcoding a
 * guessed pixel offset.
 *
 * Shopify Inbox renders as a <shopify-chat> custom element with an open
 * shadow root; the visible launcher lives inside a wrapper Shopify
 * positions with an inline `bottom`/`right` offset. Rather than depending
 * on that wrapper's current class name (undocumented and could change),
 * this looks for the first shadow-root element that is actually
 * positioned with a resolved `bottom` value.
 */
(function () {
  function findChatLauncher() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return null;

    var candidates = host.shadowRoot.querySelectorAll('*');
    for (var i = 0; i < candidates.length; i++) {
      var style = getComputedStyle(candidates[i]);
      if ((style.position === 'fixed' || style.position === 'absolute') && style.bottom !== 'auto') {
        return candidates[i];
      }
    }
    return null;
  }

  function getSafeAreaInsetBottom() {
    var probe = document.createElement('div');
    probe.style.cssText =
      'position:fixed;bottom:0;left:0;height:0;padding-bottom:env(safe-area-inset-bottom, 0px);visibility:hidden;pointer-events:none;';
    document.body.appendChild(probe);
    var value = parseFloat(getComputedStyle(probe).paddingBottom) || 0;
    probe.remove();
    return value;
  }

  function applyOffset(launcher) {
    var bar = document.querySelector('.bottom-bar');
    var barVisible = bar && getComputedStyle(bar).display !== 'none';

    if (!barVisible) {
      launcher.style.removeProperty('bottom');
      return;
    }

    var gap = 16;
    var offset = bar.getBoundingClientRect().height + getSafeAreaInsetBottom() + gap;
    launcher.style.setProperty('bottom', offset + 'px', 'important');
  }

  function onChatReady(callback) {
    var existing = findChatLauncher();
    if (existing) {
      callback(existing);
      return;
    }

    var bodyObserver = new MutationObserver(function () {
      var host = document.querySelector('shopify-chat');
      if (!host || !host.shadowRoot) return;

      var shadowObserver = new MutationObserver(function () {
        var launcher = findChatLauncher();
        if (launcher) {
          bodyObserver.disconnect();
          shadowObserver.disconnect();
          callback(launcher);
        }
      });
      shadowObserver.observe(host.shadowRoot, { childList: true, subtree: true });

      var launcher = findChatLauncher();
      if (launcher) {
        bodyObserver.disconnect();
        shadowObserver.disconnect();
        callback(launcher);
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  onChatReady(function (launcher) {
    var reapply = function () {
      applyOffset(launcher);
    };
    reapply();
    window.addEventListener('resize', reapply);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', reapply);
    }
  });
})();
